/**
 * Generates a user acronym for the given string
 */
export function getUserAcronym(username: string) {
  const usernameParts = username.replace(/[ |_|-|.]/i, '.').split('.');
  const acronym = (usernameParts[0] ?? '?')[0] + ((usernameParts[1] ?? '')[0] ?? '');
  return acronym;
}
